import { render } from "./BitcoinChart.vue?vue&type=template&id=5e924f58&ts=true"
import script from "./BitcoinChart.vue?vue&type=script&lang=ts"
export * from "./BitcoinChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__